// extracted by mini-css-extract-plugin
export var infoRow = "_un-2";
export var labelContainer = "_un-0";
export var rightInfo = "_un-1";